import * as Yup from "yup";
import Const from "./constant";

export const dateValidation = () => {
  const dateValidator = Yup.date().typeError(Const.MESSAGES.REQUIRED_FIELD);
  return Yup.array().of(dateValidator.nullable()).nullable().min(1, Const.MESSAGES.REQUIRED_FIELD).nullable().required("The value must be date");
};
